/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { JobSiteNameListProjectsInner } from "client";
import { useContext, createContext } from "react";

export interface ProjectInfo extends JobSiteNameListProjectsInner {
  jobSiteId: string;
  jobSiteName?: string;
  mapId: string;
}

export interface UserContext {
  email?: string;
  roleName?: string;
  firstName?: string;
  lastName?: string;
  jobsite?: ProjectInfo;
}

const defaultValue: UserContext = {};

export const userContext = createContext(defaultValue);

export const useUserContext = () => {
  return useContext(userContext);
};
